import { LogoutButton } from '@features/authentication/components';
import { LanguageSwitcher } from '@features/language';
import { useSelectedProductionSelectors } from '@features/productions';
import {
    ChevronRightIcon,
    MagnifyingGlassIcon,
    PersonIcon,
} from '@radix-ui/react-icons';
import { DropdownMenu, Flex, IconButton, Text } from '@radix-ui/themes';
import {
    AdvancedSearchPagePath,
    HomePagePath,
    ProductionsSelectionPagePath,
} from '@router/constants';
import BrandLogo from '../Brand/BrandLogo';
import { AppLink } from '../Link/AppLink';
import { PermissionCheck, ProtectionLevel } from '@router';
import { ServiceOrderButton } from './ServiceOrderButton';

import styles from './Header.module.css';

export const Header = () => {
    const { selectedProduction } = useSelectedProductionSelectors();

    return (
        <Flex className={styles.header} gap={'5'} align='center'>
            <AppLink className={styles.link} to={HomePagePath}>
                <BrandLogo />
            </AppLink>

            <PermissionCheck
                level={
                    ProtectionLevel.AUTHENTICATED |
                    ProtectionLevel.PRODUCTION_SELECTED
                }
            >
                <Flex align={'center'} flexGrow={'1'} gap={'2'}>
                    <AppLink
                        className={styles.link}
                        to={ProductionsSelectionPagePath}
                    >
                        <Text
                            size={'3'}
                            weight={'regular'}
                            wrap={'nowrap'}
                            color={'gray'}
                            highContrast
                        >
                            <Flex gap={'0'} flexShrink={'0'} align={'center'}>
                                {selectedProduction?.name}
                                <ChevronRightIcon
                                    width={'16px'}
                                    height={'16px'}
                                />
                            </Flex>
                        </Text>
                    </AppLink>
                </Flex>
            </PermissionCheck>

            <PermissionCheck
                level={
                    ProtectionLevel.AUTHENTICATED |
                    ProtectionLevel.PRODUCTION_SELECTED
                }
            >
                {/* 👇 Wrapped the action icons in a Flex container */}
                <Flex align={'center'} gap={'2'}>
                    <ServiceOrderButton />

                    <IconButton
                        className={styles.settings}
                        variant={'ghost'}
                        radius={'full'}
                        style={{ color: 'inherit' }}
                        asChild
                    >
                        <AppLink
                            className={styles.link}
                            to={AdvancedSearchPagePath}
                        >
                            <MagnifyingGlassIcon
                                height={'20px'}
                                width={'20px'}
                            />
                        </AppLink>
                    </IconButton>
                </Flex>
            </PermissionCheck>

            <DropdownMenu.Root>
                <DropdownMenu.Trigger>
                    <IconButton
                        className={styles.settings}
                        variant={'ghost'}
                        radius={'full'}
                        color={'gray'}
                        highContrast
                        asChild
                    >
                        <PersonIcon height={'20px'} width={'20px'} />
                    </IconButton>
                </DropdownMenu.Trigger>

                <DropdownMenu.Content>
                    <Flex direction={'column'}>
                        <LanguageSwitcher />
                        <PermissionCheck level={ProtectionLevel.AUTHENTICATED}>
                            <DropdownMenu.Separator />
                            <LogoutButton />
                        </PermissionCheck>
                    </Flex>
                </DropdownMenu.Content>
            </DropdownMenu.Root>
        </Flex>
    );
};

export default Header;
